"use client";
import { useEffect } from "react";
import {
  resyncThemeMode,
  syncWithSystemMode,
} from "@/hooks/useThemeMode";
import { DARK_MEDIA_QUERY } from "@/utils/theme-mode/theme-mode";

/**
 * Keeps the light/dark mode correct after first paint (the boot script in <head> owns
 * first paint). Mounted once from the root layout, and only for tenants with dark mode
 * enabled, so it works even on pages without a header toggle.
 *
 * Deliberately NO `storage` listener: a choice made in another tab is adopted on that
 * tab's next load, not pushed live into this one.
 */
const ThemeModeSync = () => {
  useEffect(() => {
    const media = window.matchMedia?.(DARK_MEDIA_QUERY);
    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) resyncThemeMode();
    };
    media?.addEventListener("change", syncWithSystemMode);
    window.addEventListener("pageshow", onPageShow);
    return () => {
      media?.removeEventListener("change", syncWithSystemMode);
      window.removeEventListener("pageshow", onPageShow);
    };
  }, []);
  return null;
};

export default ThemeModeSync;
